var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiTsHouseBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.041,13.641l-5.449-4.264c-.643-.504-1.54-.504-2.185,0L.96,13.641c-.61,.477-.96,1.194-.96,1.969v8.391H15V15.609c0-.774-.35-1.492-.959-1.969Zm-.041,9.359H1v-7.391c0-.465,.21-.896,.576-1.182l5.447-4.264c.281-.219,.673-.219,.952,0l5.449,4.264c.365,.286,.575,.717,.575,1.182v7.391Zm-9-3h5v-5H5v5Zm1-4h3v3h-3v-3Zm12-3h2v1h-2v-1Zm0,4h2v1h-2v-1ZM14,5h2v1h-2v-1Zm6,1h-2v-1h2v1Zm-6,3h2v1h-2v-1Zm4,0h2v1h-2v-1Zm6-6.5V24h-7v-1h6V2.5c0-.827-.673-1.5-1.5-1.5H12.5c-.827,0-1.5,.673-1.5,1.5v6.5l-1-.783V2.5c0-1.379,1.121-2.5,2.5-2.5h9c1.379,0,2.5,1.121,2.5,2.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiTsHouseBuilding);
export default __webpack_public_path__ + "static/media/fi-ts-house-building.219ccd2d40676ba8fdb301393296d7a4.svg";
export { ForwardRef as ReactComponent };